<script lang="ts" setup>
import { ref } from 'vue';
import PageMenu from './PageMenu.vue';
import useRegistrationUrl from '../hooks/registration';

const registrationUrl = useRegistrationUrl();
const hamburgerActive = ref(false);
</script>

<template>
  <header>
    <div class="header-area header-style-two">
      <div class="container">
        <div class="row">
          <!-- eslint-disable-next-line unocss/order -->
          <div class="col-lg-12 align-items-center d-xl-flex col-xl-2 col-md-12 col-sm-12 col-xs-12">
            <!-- eslint-disable-next-line unocss/order -->
            <div class="align-items-center d-flex logo justify-content-end">
              <!-- <RouterLink to="/"><img src="../assets/images/logo.png" alt="logo" class="h-56 w-171 object-contain"></RouterLink> -->

              <div class="d-flex mobile-menu d-xl-none">
                <!-- <a href="javascript:;" class="d-block d-xl-none hamburger" :class="{ 'h-active': hamburgerActive }" @click="hamburgerActive = !hamburgerActive">
                  <span class="h-top"></span>
                  <span class="h-middle"></span>
                  <span class="h-bottom"></span>
                </a> -->
                <a :href="registrationUrl" class="mobile-register-btn my-27" target="_blank">
                  <span>报名</span>
                </a>
              </div>
            </div>
          </div>

          <PageMenu v-model:hamburger="hamburgerActive" />

          <div class="d-none d-xl-block col-2 col-xl-3">
            <div class="d-flex align-items-center nav-right justify-content-end h-100">
              <ul class="d-flex align-items-center nav-right-list">
                <li class="nav-btn">
                  <a class="primary-btn-fill" :href="registrationUrl" target="_blank">报名</a>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.mobile-register-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  overflow: hidden;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  background: linear-gradient(135deg, #1180ff 0%, #4dabf7 100%);
  border: none;
  border-radius: 18px;
  box-shadow: 0 2px 8px rgba(17, 128, 255, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    content: "";
  }

  span {
    position: relative;
    z-index: 1;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(17, 128, 255, 0.4);
    transform: translateY(-2px);

    &::before {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(0);
    transition: transform 0.1s ease;
  }

  // 添加微妙的脉冲动画
  &::after {
    position: absolute;
    top: 50%;
    right: auto;
    bottom: auto;
    left: 50%;
    width: 0;
    height: 0;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.4s ease;
    content: "";
  }

  &:hover::after {
    width: 100px;
    height: 100px;
  }

  // 响应式适配
  @media (max-width: 390px) {
    height: 32px;
    padding: 0 14px;
    font-size: 13px;
    border-radius: 16px;
  }

  @media (max-width: 320px) {
    height: 28px;
    padding: 0 12px;
    font-size: 12px;
    border-radius: 14px;
  }
}
</style>
